import { BaseBus } from "./BaseBus";
import { TaxCodeBus } from "./TaxCodeBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { CustomPricingBus } from "./CustomPricingBus";

export class BaseInvBus extends BaseBus
{
    constructor(data: BaseInvBus = null) {
        super(data);
    }
    initialize(data: BaseInvBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.setOtherProperties();
        //    this.taxTypeCode = 0;
        //    if (this.hasId) {
        //        if (CommonFunctions.hasNumberValue(this.useTax)) {
        //            this.taxTypeCode = 2;
        //        }
        //        else if (CommonFunctions.hasNumberValue(this.taxAmount)) {
        //            if (this.taxCode != null) {
        //                if (this.taxCode.isAvalara) {
        //                    this.taxTypeCode = 1;
        //                }
        //                else if (this.taxCode.isRetailTax) {
        //                    this.taxTypeCode = 1;
        //                }
        //            }
        //            else {
        //                this.taxTypeCode = 1;
        //            }
        //        //    if (this.taxCode != null && !this.taxCode.isAvalara && this.taxCode.isRetailTax) {
        //        //        this.taxTypeCode = 1;
        //        //    }
        //        }
        //    }
        }
        catch {

        }

    }
    setOtherProperties() {

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateDt = date;
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.companyId = companyId;
            this.updateDt = date;
            this.updateUserId = userId;
        }
    }
    //setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    //    this.invoiceDate = date;
    //    this.invoiceStatusId = CommonValues.Invoice_Pending;
    //}
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setTaxCode(taxCode: TaxCodeBus = null) {
        this.taxCode = new TaxCodeBus(taxCode);
    }
    setCustomPricing(pricing: CustomPricingBus = null) {
        this.customPricing = new CustomPricingBus(pricing);
    }

    public companyId: any;
    public customerId: any;
    public locationId: any;
    public accountClassId: any;
    public taxCodeId: any;
    public termId: any;
    public taxAmount: number;
    public cost: number;
    public costLabor: number;
    public costMaterial: number;
    public costOther: number;
    public saleLabor: number;
    public saleMaterial: number;
    public saleOther: number;
    public amount: number;
    public total: number;
    public insertDt: Date;
    public insertUserId: any;
    public updateDt: Date;
    public updateUserId: any;
    public useTax: number;
    public taxTypeCode: number; //0-Unknown, 1-Sales, 2-Use
    public isAvalara: boolean;
    public taxCode: TaxCodeBus;
    public customPricing: CustomPricingBus;
    get hasTaxCode(): boolean {
        return CommonFunctions.hasValue(this.taxCode);
    }
    get hasCustomPricing(): boolean {
        return CommonFunctions.hasValue(this.customPricing);
    }
}
